<template>
</template>

<script>
export default {
	name: "NotFound",
	data() {
    },
	async mounted() {
		this.$router.push({name: 'dashboard'})
	},
}

</script>

<style scoped>

</style>